import React, { useState } from 'react'
import "./Main_wallet_btn_card.css"
import Main_wallet_card_lottie from '../../../../animations/main_wallet_card_lottie/Main_wallet_card_lottie'
import Yellow_arrow_btn from '../../../../common_components/common_btn/yellow_arrow_btn/Yellow_arrow_btn'
import White_btn from '../../../../common_components/common_btn/white_btn/White_btn'
import Orange_btn from '../../../../common_components/common_btn/orange_btn/Orange_btn'
import { useNavigate } from 'react-router-dom'
import Successfull_Modal from '../../../../common_components/common_modal/successfull_modal/Successfull_Modal'
import Success_Lottie from '../../../../animations/success_lottie/Success_Lottie'
import Download_modal from '../../../../common_components/common_modal/download_modal/Download_modal'

function Main_wallet_btn_card({ animationData }) {
    const [modalShow, setModalShow] = useState(false);
    const [modalDownloadShow, setDownloadModalShow] = React.useState(false);
    const navigate = useNavigate();

    return (
        <>
            <section className='Main_wallet_btn_card'>
                <div className="row">
                    <div className="col-md-2 col-sm-2">
                        <div className="card_lottie_holder">
                            <Main_wallet_card_lottie animationData={animationData} />
                        </div>
                    </div>

                    <div className="col-md-10 col-sm-10">
                        <div className="contant_holder">
                            <div className="row">
                                <div className="col-md-6 col-sm-6 col-6">
                                    <div className="name_hodler">
                                        <h6>Team Bonus</h6>
                                    </div>
                                </div>

                                <div className="col-md-6 col-sm-6 col-6">
                                    <div className="count_hodler">
                                        <h5>756.00</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="line_text_hodler">
                                <p>Points</p>
                            </div>
                            <div className="btns_holder">
                                <Orange_btn btnText="View Income" onClick={() => navigate("/main-wallet-task-income")} />
                                <White_btn btnText="Transfer To Wallet" onClick={() => setDownloadModalShow(true)} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Successfull_Modal
                show={modalShow}
                message="Transfer Successful!"
                subMessage="Your amount has been credited to your wallet."
                onHide={() => setModalShow(false)}
                lottie={<Success_Lottie />}
            />

            <Download_modal
                show={modalDownloadShow}
                onHide={() => setDownloadModalShow(false)}
            />
        </>
    )
}

export default Main_wallet_btn_card